import { Tooltip } from "antd";
import React from "react";
import { useDeepCompareMemo } from "use-deep-compare";
import styles from "./styles.module.sass";
import { demoModeAtom } from "../../../../../atoms";
import { useRecoilValue } from "recoil";

interface IProps {
  image?: string;
  imageSize?: "small" | "large";
  name: string;
  subTitle?: string;
}

export const CustomerBox: React.FC<IProps> = (props) => {
  const { image, name, subTitle } = props;
  const demoMode = useRecoilValue(demoModeAtom);
  const avatar = useDeepCompareMemo(
    () => (image ? process.env.REACT_APP_ENDPOINT + image : undefined),
    [image]
  );
  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        {avatar ? (
          <img
            style={
              demoMode ? { filter: "blur(5px)", pointerEvents: "none" } : {}
            }
            alt='avatar'
            className={styles.avatar}
            src={avatar}
          />
        ) : (
          <span className={styles.customerName}>{name?.[0]}</span>
        )}
      </div>

      <div>
        {name.length > 18 ? (
          <Tooltip title={name}>
            <span
              style={
                demoMode ? { filter: "blur(5px)", pointerEvents: "none" } : {}
              }
            >
              {name}
            </span>
          </Tooltip>
        ) : (
          <span
            style={
              demoMode ? { filter: "blur(5px)", pointerEvents: "none" } : {}
            }
          >
            {name}
          </span>
        )}
        {subTitle && (
          <span
            style={
              demoMode ? { filter: "blur(5px)", pointerEvents: "none" } : {}
            }
            className={styles.subTitle}
          >
            {subTitle}
          </span>
        )}
      </div>
    </div>
  );
};
